var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gridicons:not-visible"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 12C1 12 5.188 6 12 6C12.947 6 13.839 6.121 14.678 6.322L8.36 12.64C8.12415 12.1254 8.00139 11.5661 8 11C8 10.063 8.335 9.213 8.875 8.531C6.483 9.343 4.661 10.916 3.621 12C4.50694 12.9243 5.50856 13.7303 6.601 14.398L5.148 15.851C2.497 14.13 1 12 1 12ZM23 12C23 12 18.812 18 12 18C11.054 18 10.164 17.876 9.324 17.677L5 22L3.5 20.5L20.5 3.5L22 5L18.853 8.147C21.501 9.869 23 12 23 12ZM20.385 12.006C19.4975 11.0791 18.4934 10.2714 17.398 9.603L16 11C16 12.0609 15.5786 13.0783 14.8284 13.8284C14.0783 14.5786 13.0609 15 12 15L11.053 15.947C11.363 15.978 11.677 16 12 16C15.978 16 18.943 13.522 20.385 12.006Z",
    fill: "#495568",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/CloseEye.8abcbf04d1f16fee30e962b5da40a7df.svg";
export { ForwardRef as ReactComponent };